import styled from 'styled-components';

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: var(--Spacing-8, 8px) 16px;
    justify-content: center;
    align-items: center;
    gap: var(--Spacing-8, 8px);
    flex: 1 0 0;
    width: 420px;
    min-height: 40px;
    border-bottom: 1px solid #6a717e;
    background: #fff;

    &:has(input:focus) {
        border-color: #EC6643;
    }

    &:has(input:disabled) {
        cursor: not-allowed;
        background: ${(props) => props.theme['white-300']};
        button {
        cursor: not-allowed;
        }
    }
`;

export const SearchInput = styled.input`
  all: unset;
  width: 100%;
  color: #6a717e;
  font-size: 1rem;

  ::placeholder {
    color: #9ca3af;
  }
`;

export const SearchButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4b5563;
  line-height: 0;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;